import type { ComponentProps } from 'react';
import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/UI/Box';
import Button, { type ButtonVariant } from '@/components/UI/Button';
import Text from '@/components/UI/Text';
import Icon from '@/components/Unistyles/Icon';

type SignInButtonProps = {
  onPress(): void;
  title: string;
  icon: ComponentProps<typeof Icon>['name'];
  variant: ButtonVariant;
  outline?: boolean;
};

export default function SignInButton({
  onPress,
  title,
  icon,
  variant,
  outline,
}: SignInButtonProps) {
  return (
    <Button
      variant={variant}
      appearance={outline ? 'outline' : 'solid'}
      onPress={onPress}
      style={style.button}
    >
      <Box>
        <Icon name={icon} size="2xl" />
      </Box>
      <Text size="xl">{title}</Text>
    </Button>
  );
}

const style = StyleSheet.create((theme) => ({
  button: {
    flexDirection: 'row',
    paddingVertical: theme.space(2),
    paddingHorizontal: theme.space(4),
    gap: theme.space('md'),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.borderRadius.xl,
    width: theme.size(72),
  },
}));
